import { http } from './config';

const PARCEIRO_PROJECT_PATH = 'parceiro-project';
const ESTENDER_PRAZO_PATH = 'parceiro-project-reminder';

export default {
  listar: object => {
    let params = `page=${object.page ? object.page : 1}&codigoParceiro=${
      object.codigoParceiro
    }`;

    if (object.nome) {
      params += `&nome=${object.nome}`;
    }

    return http.get(`${PARCEIRO_PROJECT_PATH}?${params}`);
  },

  create: project =>
    http.post(`${PARCEIRO_PROJECT_PATH}/${project.codigo}`, project),

  get: ({ id }) => http.get(`${PARCEIRO_PROJECT_PATH}/${id}`),

  deletar: ({ projectId }) =>
    http.delete(`${PARCEIRO_PROJECT_PATH}/${projectId}`),

  atualizarStatus: ({
    projectId,
    newStatus,
    concessionariaId,
    colaboradorId,
    protocolo
  }) => {
    const body = { status: newStatus };
    if (concessionariaId != null && concessionariaId !== '') {
      body.concessionariaId = concessionariaId;
    }
    if (colaboradorId != null && colaboradorId !== '') {
      body.colaboradorId = colaboradorId;
    }
    if (protocolo !== undefined) {
      body.protocolo = protocolo === '' ? null : protocolo;
    }
    return http.post(
      `${PARCEIRO_PROJECT_PATH}/${projectId}/update-status`,
      body
    );
  },

  atualizar: project =>
    http.post(`${PARCEIRO_PROJECT_PATH}/${project._id}/update`, project),

  estenderPrazo: ({ projectId, novoPrazo }) =>
    http.post(`${ESTENDER_PRAZO_PATH}/estender-prazo`, {
      projectId,
      novoPrazo
    }),

  getStatusReport: ({ codigoParceiro, ano }) => {
    const params = new URLSearchParams();
    params.append('codigoParceiro', codigoParceiro);
    if (ano != null && ano !== '') params.append('ano', ano);
    return http.get(
      `${PARCEIRO_PROJECT_PATH}/status-report?${params.toString()}`
    );
  },

  getRelatorioAnaliseReanalise: ({ codigoParceiro, ano, mes }) => {
    const params = new URLSearchParams();
    params.append('codigoParceiro', codigoParceiro);
    params.append('ano', ano);
    params.append('mes', mes);
    return http.get(
      `${PARCEIRO_PROJECT_PATH}/relatorio-analise-reanalise?${params.toString()}`
    );
  }
};
